/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {ButtonBase, Grid, Typography} from "@mui/material";
import {AccountBalanceWallet, Menu} from "@mui/icons-material";
import {useContext, useEffect, useState} from "react";
import {useAnimate} from "framer-motion";
import IconoAvatarPerfil from "./SubComponentes/IconoAvatarPerfil";
import {useMediaQuery} from "@mui/system";
import {theme} from "../../Tema";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";
import {usuarioContext} from "../../App";
import {obtenerTotalBolsillos} from "../../CodNegocio/Bolsillo/obtenerTotalBolsillos";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Barra = ({setOpen, open, seccionesPerfil}) => {
    const {sCell} = useResponsive()
    const cData = useContext(usuarioContext)
    const masSM = useMediaQuery(theme.breakpoints.up('md'))
    const [navegando, setNavegando] = useState(false)
    const [scope, animate] = useAnimate()
    const [opaco, setOpaco] = useState(1)
    const [openPerfil, setOpenPerfil] = useState(false)
    const [openPerfilNotificacion, setOpenPerfilNotificaciones] = useState(false)
    const [totalBolsillo, setTotalBolsillo] = useState(0)


    useEffect(() => {


        window.addEventListener('scroll', (e) => {
            if (window.scrollY > 50 && !navegando) {
                setNavegando(true)
            } else if (window.scrollY < 50) {
                setNavegando(false)
            }

        });


        if (scope.current && masSM) {
            setOpaco(0)
            animate(scope.current, {x: -200, transitionDuration: 0})
            setTimeout(() => {
                setOpaco(1)
                if (scope.current) {
                    animate(scope.current, {x: 1, transitionDuration: 0})
                }

            }, 500)
        }


    }, [open]);
    useEffect(() => {
        if (cData && cData.usuario) {

            let id = cData.usuario.id;
            obtenerTotalBolsillos({idUsuario: id}).then((res) => {
                setTotalBolsillo(res)
            })
        }
    }, [cData])
    return (
        <Grid
            container
            size={12}
            alignItems={'center'}
            sx={{
                px: masSM ? 4 : 3,
                py: 2,
                boxShadow: navegando ? 3 : 0,
                position: 'fixed',
                top: '0%',
                backgroundColor: '#fff',
                pr: open && masSM ? 36 : !masSM ? 3 : 13
            }}
        >

            <Grid size={{xs: 2, sm: 4, md: 1}}>
                <ButtonBase
                    onClick={() => setOpen((e) => !e)}
                >
                    <Menu/>
                </ButtonBase>

            </Grid>

            <Grid size={{xs: 1, sm: 2, md: 6}}>

            </Grid>

            <Grid
                ref={scope}
                container size={{xs: 9, sm: 6, md: 5}} justifyContent={'flex-end'} alignItems={'center'}
                sx={{
                    opacity: opaco,
                    pr: (openPerfil || openPerfilNotificacion) && masSM ? 1.7 : 0,
                }}
                spacing={!masSM ? 1 : 6}
            >


                <Grid container size={{xs: 10, sm: 10, md: 10}} justifyContent={'flex-end'}>
                    {/* <IconoNotificaciones color={'info'} sx={{width: 20, height: 20}}
                                         setOpenPerfilNotificaciones={setOpenPerfilNotificaciones}
                                         openPerfilNotificacion={openPerfilNotificacion}/> */}

                    <Typography
                        sx={{fontSize: 18, fontWeight: 700}}>
                        <AccountBalanceWallet sx={{pr: 1, mt: 0.5, mb: -0.5}}/>
                        {(sCell ? '' : 'Total ') + `Ahorros: ${formatoMoneda(totalBolsillo)}`}</Typography>
                </Grid>

                <Grid container size={{xs: 2, sm: 2, md: 2}} justifyContent={'flex-end'}>
                    <IconoAvatarPerfil openPerfil={openPerfil} setOpenPerfil={setOpenPerfil}
                                       seccionesPerfil={seccionesPerfil}/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Barra